import * as React from "react";
import { Pirsch } from "pirsch-sdk/web";
import { PirschClientContext } from "./PirschClientContext";

const isBot = () => {
  if (typeof window === "undefined") {
    return false;
  }

  const userAgent = window.navigator.userAgent;

  if (!userAgent) {
    return true;
  }

  const regex = /bot|google|lighthouse|baidu|bing|msn|teoma|slurp|yandex/i;

  return regex.test(userAgent);
};

export const PirschClientProvider = ({ children }) => {
  const isVisitorBot = isBot();

  const client = React.useRef(
    new Pirsch({
      identificationCode: "lesv8bsibsCLaKrdKNNRue8LP6I0PyBL",
      hostname: "toiletsofberlin.com",
    }),
  );

  if (isVisitorBot) {
    return children;
  }

  return (
    <PirschClientContext.Provider value={client.current}>
      {children}
    </PirschClientContext.Provider>
  );
};
